import useSWR from 'swr'
import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { DemoConversationService } from '@forwardflow/services/DemoConversation'

const useCampaigns = (type: string) => {
  const { data, error, isLoading, isValidating, mutate } = useSWR(
    type ? [QUERY_KEYS.CAMPAIGN_DETAILS, type] : null,
    ([, campaignType]) => DemoConversationService.getCampaignsByType(campaignType),
    {
      revalidateOnFocus: false,
      errorRetryCount: 2,
      shouldRetryOnError: true,
    }
  )

  return {
    data: data,
    error,
    isLoading,
    isValidating,
    mutate
  }
}

export default useCampaigns